export default __webpack_public_path__ + "static/media/tv.b2d49632.svg";